
<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<h2 mat-dialog-title>{{'key-management.upload-key-dialog.title' | translate}}</h2>

<mat-dialog-content>
    <form [formGroup]="fg">

        <div class="form-container">
            <div class="upload-button-row">
                <input type="file" name="file" style="display: none" formControlName="file" (change)="setFile($event)" #fileUpload>
                <mat-form-field appearance="outline" class="name-form-field">
                    <mat-label>{{'FILENAME' | translate}}</mat-label>
                    <input matInput type="text" readonly value="{{file?.name}}">
                    <button style="vertical-align: super;" mat-icon-button matSuffix (click)="fileUpload.click()" color="primary"
                            matTooltip="{{'key-management.upload-key-dialog.select-file' | translate}}">
                        <span class="mdi mdi-dots-horizontal dots-horizontal-icon"></span>
                    </button>
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="outline" class="name-form-field">
                    <mat-label>{{'key-management.upload-key-dialog.key-name' | translate}}</mat-label>
                    <input matInput type="text" name="name" formControlName="name" maxlength="255">
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="outline" class="name-form-field">
                    <mat-label>{{'ADU_PASS' | translate}}</mat-label>
                    <span style="display: flex;">
                      <input matInput type="password" name="password" formControlName="password" (input)="tooltip?.show()"
                          (capsLock)="onCapsLockChanged($event)" (focus)="passwordFocus()" (blur)="passwordBlur()">
                      @if (capsOn) {
                        <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon" #tooltip="matTooltip"
                          matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}" matTooltipPosition="right">
                        </mat-icon>
                      }
                    </span>
                </mat-form-field>
                <p class="password-warning" *ngIf="displayPasswordWarning">
                    <span class="mdi mdi-information" aria-hidden="true"></span> {{'key-management.upload-key-dialog.password-warning' | translate}}
                </p>
            </div>

            <div>
                <mat-checkbox class="example-margin" (change)="expirationToggle($event)">{{'key-management.upload-key-dialog.key-expires' | translate}}</mat-checkbox>
                <mat-form-field class="expiration-date-field" appearance="outline">
                    <mat-label>{{'key-management.upload-key-dialog.expiration-date' | translate}}</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="expirationDate">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

    </form>
</mat-dialog-content>

<mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onClickCancel()">{{'CANCEL' | translate}}</button>
    <button mat-raised-button [disabled]="!fg.valid" (click)="onClickOK()">{{'OK' | translate}}</button>
</mat-dialog-actions>
